/**
 * 页脚组件
 *
 * 版权信息 + 相关链接
 * 简洁现代风格
 */

import React from 'react';
import { homePageContent } from './homePageContent';

export const FooterSection: React.FC = () => {
  const { footer } = homePageContent;

  return (
    <footer className="bg-gray-900 text-gray-400 py-12 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo/品牌 */}
          <span className="text-xl font-bold text-white">星曜智创</span>

          {/* 链接 */}
          <div className="flex flex-wrap justify-center gap-6">
            {footer.links.map((link, index) => (
              <a
                key={index}
                href={link.href}
                {...(link.href.startsWith('/') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="text-sm hover:text-white transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* 版权 */}
          <p className="text-sm text-gray-500">
            {footer.copyright}
          </p>
        </div>

        {/* ICP备案 + 公安备案 */}
        <div className="text-center mt-6 pt-6 border-t border-gray-800">
          <p className="text-sm text-gray-500 flex flex-wrap items-center justify-center gap-4">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              鲁ICP备2026018158号-1
            </a>
            <span className="text-gray-700">|</span>
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=37050202371617"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition-colors flex items-center gap-1"
            >
              <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="公安备案" className="w-4 h-4 inline-block" />
              鲁公网安备37050202371617号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
